import { FileType } from "../../components/file-explorer";
import { GitEntry } from "../../services/repo-service";
import { CustomTreeViewBaseItem, FilePathContent, FileState } from "../models/common-models";

export enum Repo_Type {
    flows = "flows",
    blocks_Evaluator = 'blocks-evaluator',
    blocks_Transformer = 'blocks-transformer',
    blocks_DataEnricher_API = 'blocks-data-enricher-api',
    blocks_DataEnricher_DB_Lookup = 'blocks-data-enricher-db-lookup',
    blocks_DataEnricher_Graph_Lookup = 'blocks-data-enricher-graph-lookup',
    blocks_DataEnricher_ML_Prediction = 'blocks-data-enricher-ml-prediction',
    blocks_Push_Webhook = 'blocks-push-webhook',
    blocks_Push_DB = 'blocks-push-db',
    blocks_Push_Queue = 'blocks-push-queue',
    blocks_Notification_Email = 'blocks-notification-email',
    blocks_Notification_Slack = 'blocks-notification-slack',
    system = 'system',
}

export const OWNER = "Centurion"

export const PACKAGE_TYPE = "container"

export const ReposByBlockType: { [type: string]: string } = {
    'evaluator': 'blocks-evaluator',
    'transformer': 'blocks-transformer',
    'api': 'blocks-data-enricher-api',
    'db-lookup': 'blocks-data-enricher-db-lookup',
    'graph-lookup': 'blocks-data-enricher-graph-lookup',
    'ml-prediction': 'blocks-data-enricher-ml-prediction',
    'webhook': 'blocks-push-webhook',
    'db': 'blocks-push-db',
    'queue': 'blocks-push-queue',
    'email': 'blocks-notification-email',
    'slack': 'blocks-notification-slack',
    'system': 'system',
}


//  encode
export const utf8ToBase64 = (data: string | ArrayBuffer, isBinary: boolean = false): string => {
    const utf8Array = isBinary ? new Uint8Array(data as ArrayBuffer) : new TextEncoder().encode(data as string);

    let binaryString = '';
    utf8Array.forEach(byte => {
        binaryString += String.fromCharCode(byte);
    });
    return btoa(binaryString);
};

// decode
export const base64ToUtf8 = (base64String: string): string => {
    const binaryString = atob(base64String);
    const utf8Array = Uint8Array.from(binaryString, char => char.charCodeAt(0));
    const decoder = new TextDecoder();
    return decoder.decode(utf8Array);
};

export const getFilePathsAndContents = (tree: CustomTreeViewBaseItem[], fileStates: FileState, basePath: string = ''): FilePathContent[] => {
    let filePaths: FilePathContent[] = [];

    for (const item of tree) {
        const currentPath = basePath ? `${basePath}/${item.label}` : item.label;

        if (item.children && item.children.length > 0) {
            filePaths = filePaths.concat(getFilePathsAndContents(item.children, fileStates, currentPath));
        } else if (fileStates[item.id]) {
            filePaths.push({
                path: currentPath,
                filename: item.label,
                content: fileStates[item.id]
            });
        }
    }

    return filePaths;
}

// Function to convert GitTreeResponse to a CustomTreeViewBaseItem structure
export const convertGitTreeToTreeView = (tree: GitEntry[], supportedFileType: { [key: string]: FileType }): CustomTreeViewBaseItem[] => {
    const map = new Map<string, CustomTreeViewBaseItem>();

    tree.forEach(item => {
        const parts = item.path?.split('/') || [];
        let parentPath = '';

        parts.forEach((part, index) => {
            const isLastPart = index === parts.length - 1;
            const fullPath = `${parentPath}${part}`;

            if (!map.has(fullPath)) {
                const type = isLastPart && item.type === 'blob' ? 'file' : 'folder';
                const pathTypeArray: string[] | undefined = item.path?.split('.');
                const fileType: FileType = pathTypeArray ? (supportedFileType[pathTypeArray[pathTypeArray.length - 1]] || (type === 'folder' ? 'pinned' : type)) : type;
                const newItem: CustomTreeViewBaseItem = {
                    id: fullPath,
                    label: part,
                    path: fullPath,
                    type: type,
                    fileType: fileType,
                    parentId: index === 0 ? null : parentPath.slice(0, -1),
                    children: [],
                };
                map.set(fullPath, newItem);

                // Add the newItem to its parent
                if (parentPath) {
                    const parent = map.get(parentPath.slice(0, -1)); // Remove the trailing slash
                    if (parent && parent.type === 'folder') {
                        parent.children = parent.children || [];
                        parent.children.push(newItem);
                    }
                }
            }
            parentPath = `${fullPath}/`;
        });
    });

    return Array.from(map.values()).filter(item => !item.path?.includes('/') && !item.id.startsWith('.'));
};